(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['./console'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(require('./console'));
    } else {
        root.group = factory(root.konsole);
    }
})(this, function (konsole) {
    'use strict';
    var	_noop = function () {};
    var group = {
        start: konsole.trueConsole && function (ns) {
            if (ns != null) {
                if (group.current !== ns) {
                    group.end();
                    group.current = ns;
                    konsole.group(ns);
                }
            }
        } || _noop,
        end: konsole.trueConsole && function (ns) {
            if (group.current !== '') {
                group.current = '';
                konsole.groupEnd(ns);
            }
        } || _noop,

        current: ''
    };

    return group;
});
